import { LongSize } from '../../product_detail/components/size.enum';

export enum Size {
  '?' = -999,
  'XS' = 0,
  'S' = 1,
  'M' = 2,
  'L' = 3,
  'XL' = 4,
  '1X' = 5,
  '2X' = 6,
  '3X' = 7,
  '4X' = 8,
}

export const getSizeLongName = (size: Size): LongSize => {
  switch (size) {
    case Size.XS:
      return LongSize.XS;
    case Size.S:
      return LongSize.Small;
    case Size.M:
      return LongSize.Medium;
    case Size.L:
      return LongSize.Large;
    case Size.XL:
      return LongSize.XL;
    case Size['1X']:
      return LongSize['1X'];
    case Size['2X']:
      return LongSize['2X'];
    case Size['3X']:
      return LongSize['3X'];
    case Size['4X']:
      return LongSize['4X'];
    default:
      return LongSize.Small;
  }
};
